export const FETCH_SUBSCRIBER_DOCUMENTS_API = '/subscriber/documents/list';
